import moment from 'moment'
import { SkudPassageEndpoint } from '@/views/skud/shared/endpoint_services/skud-passage-endpoint-service'
import { SkudCommonEndpoint } from '@/views/skud/shared/endpoint_services/skud-common-endpoint-service'
import { loadPlaces, placeName } from '@/views/skud/shared/services/skud-places-service'
import { envelopeError } from '@/views/skud/shared/modules/skud-http'
import { Method, PassageDirection, DirectionSource, enumText } from '@/views/skud/shared/models/enums'

const DATE_FMT = 'DD.MM.YYYY HH:mm:ss'

function fmt (v) {
  return v ? moment(v).format(DATE_FMT) : null
}

export class SkudPassageService {
  constructor () {
    this.endpoint = new SkudPassageEndpoint()
    this.common = new SkudCommonEndpoint()
    this.error = null
  }

  async getPassages (placeId, filters, cursors) {
    const params = Object.assign({}, filters, { limit: 200 })
    // Дата «по» из фильтра — без времени, включаем весь день.
    if (params.to && params.to.length === 10) params.to += 'T23:59:59'
    if (cursors && cursors.next_cursor_id) {
      params.cursor_occurred_at = cursors.next_cursor_occurred_at
      params.cursor_id = cursors.next_cursor_id
    }
    const res = await this.endpoint.getPassages(placeId, params)
    if (!res) {
      this.error = envelopeError(this.endpoint.lastError)
      return { items: [], next_cursor_occurred_at: null, next_cursor_id: null }
    }
    this.error = null
    const items = (res.items || []).map(x => ({
      id: x.id,
      public_id: x.public_id,
      occurred_at: fmt(x.occurred_at),
      occurred_at_raw: x.occurred_at,
      screen: x.screen,
      revised_screen: x.revised_screen,
      offline: x.offline,
      suspicious: x.suspicious,
      direction_mismatch: x.direction_mismatch,
      method: x.method,
      method_text: enumText(Method, x.method),
      reason: x.reason,
      subject_ref: x.subject_ref,
      guest_pass_public_id: x.guest_pass_public_id,
      place_id: x.place_id,
      place_name: x.place_name,
      point_id: x.point_id,
      point_name: x.title
    }))
    return {
      items: items,
      next_cursor_occurred_at: res.next_cursor_occurred_at,
      next_cursor_id: res.next_cursor_id
    }
  }

  async getPassage (placeId, publicId) {
    const x = await this.endpoint.getPassage(placeId, publicId)
    if (!x) {
      this.error = envelopeError(this.endpoint.lastError)
      return null
    }
    this.error = null
    // Детальный ответ не содержит имён — место из кэша vending, точку ищем в справочнике места.
    await loadPlaces()
    const points = await this.common.getPoints(placeId)
    const pointName = points
      ? ((points.find(p => String(p.id) === String(x.point_id)) || {}).name || x.point_id)
      : x.point_id
    const t = x.terminal_decision || {}
    const s = x.server_decision || {}
    return {
      public_id: x.public_id,
      event_uid: x.event_uid,
      place_id: x.place_id,
      place_name: placeName(x.place_id),
      point_id: x.point_id,
      point_name: pointName,
      occurred_at: fmt(x.occurred_at),
      registered_at: fmt(x.registered_at),
      method: x.method,
      method_text: enumText(Method, x.method),
      credential_uid: x.credential_uid,
      offline: x.offline,
      clock_skew_sec: x.clock_skew_sec,
      record_version: x.record_version,
      subject_ref: x.subject_ref,
      guest_pass_public_id: x.guest_pass_public_id,
      terminal_decision: {
        screen: t.screen,
        reason: t.reason,
        direction_text: t.direction !== null && t.direction !== undefined ? enumText(PassageDirection, t.direction) : null,
        rule_index: t.rule_index
      },
      server_decision: {
        revised_screen: s.revised_screen,
        direction_text: s.direction !== null && s.direction !== undefined ? enumText(PassageDirection, s.direction) : null,
        direction_source_text: s.direction_source !== null && s.direction_source !== undefined ? enumText(DirectionSource, s.direction_source) : null,
        terminal_direction_text: s.terminal_direction !== null && s.terminal_direction !== undefined ? enumText(PassageDirection, s.terminal_direction) : null,
        direction_mismatch: s.direction_mismatch,
        suspicious: s.suspicious
      }
    }
  }
}
